const xlsx = require('xlsx')

export default function exportXls (data, fields, fileName, params) {
  try {
    var filteredData = data.map(row => {
      return Object.keys(row).filter(key => fields.includes(key)).reduce((obj, key) => {
        if (typeof row[key] === 'boolean') obj[key] = (row[key]) ? 'Ja' : 'Nein'
        else if (key.toLowerCase().includes('datum')) obj[key] = new Date(row[key]).toLocaleDateString() // Format Date String
        else if (key.toLowerCase().includes('uhrzeit') && row[key]) {
          obj[key] = new Date(row[key]).toLocaleTimeString() // Format Time String
        } else obj[key] = row[key]
        return obj
      }, {})
    })

    var wb = xlsx.utils.book_new()
    wb.SheetNames.push('Tabelle')
    wb.Sheets['Tabelle'] = xlsx.utils.json_to_sheet(filteredData, { header: fields }) // Header: Provide desired column order

    if (params) {
      wb.SheetNames.push('Einstellungen')
      wb.Sheets['Einstellungen'] = xlsx.utils.aoa_to_sheet(params)
    }

    xlsx.writeFile(wb, fileName + '.xlsx')
  } catch (err) {
    console.error(err)
  }
}



// WEBPACK FOOTER //
// ./src/components/Datatable/src/_utils/exportXls.js